import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {GoogleMap,MapCircle,MapAdvancedMarker} from '@angular/google-maps';
import { MapMarkerService } from '../../../services/map-marker.service';
import { environment } from '../../../environments/environment';
import {  Injectable, NgZone } from '@angular/core';
declare function callparentfun(): void;

//定義資料型態
interface MapMarker {
  position:  google.maps.LatLngLiteral;
  name:      string;
  stationId: string;
  branch: string;
  village: string;
  title: string;
  address: string;
  floor: string;
  capacity: string;
  lat: string;
  lng: string;
}



@Component({
  selector: 'traffic-google-map',
  standalone: true,
  //引用的功能
  imports: [GoogleMap,MapCircle,MapAdvancedMarker],
  templateUrl: './google-map.component.html',
})

@Injectable({ providedIn: 'root' })
export class GoogleMapComponent {
    @Input() defautlat: number =24.992970647147626;
    @Input() defautlng: number= 121.30099572377901;

  /*--------------------組件與服務初始化-------------------*/


  // [ClienteService] 定義服務
  constructor(private markerService: MapMarkerService,private ngZone: NgZone) {
    //利用NgZone將function 設為全域變數
    window['NgAppRef'] = { component: this, zone: this.ngZone };
    
  }

  // [GoogleMap] 子組件
  @ViewChild(GoogleMap) readonly map!: GoogleMap;

  // [callBack] 回傳父組件事件
  @Output() callBack =  new EventEmitter<{ type: string, name: string, stationId:string, branch:string, title:string, address:string, floor:string, capacity:string,village:string, lat:string, lng:string }>();




  /*--------------------地圖基礎設定---------------------*/

  // 地圖中心座標
  center: google.maps.LatLngLiteral = {lat:  this.defautlat, lng: this.defautlng};

  mapCenter: google.maps.LatLngLiteral = {lat:  this.defautlat, lng:this.defautlng};
  // 預設地圖大小
  zoom = 15;

  // 其他不會變動的設定值
  options: google.maps.MapOptions = {

    //地圖大小區間
    maxZoom: 30,
    minZoom: 5,

    //(必填)地圖標記功能使用
    mapId: "MAP_Markers",

    // 除了地圖大小控制項，其他UI介面不顯示
    streetViewControl: false,
    fullscreenControl:false,
    mapTypeControl:false,

    // 地圖大小控制項預設位置: 4.0(左側中間)
    zoomControlOptions: {
      position: 4.0
    }
  };


  /*--------------------中心圓圈半徑顯示---------------------*/



  //半徑(公尺)
  radius = environment.trafficSize;


  circleOptions :google.maps.CircleOptions  ={
    //填滿
    fillOpacity:0.05,

    //邊框
    strokeOpacity:0.2,
    strokeWeight:1,
  }


  /*--------------------交通方式地圖標記--------------------*/
  //顯示類別
  type ="ALL";

  //地圖標記

  boatMarkers: MapMarker[] = [];
 





 /*--------------------angular 預設 funtion()---------------------*/

  /**
  * ngOnInit(初始化後呼叫)
  */
  ngOnInit(){

    //市區交通船
    this.markerService.getBoat().subscribe((boatObject:any) => {
      this.boatMarkers = [];
      for(let stmap of boatObject){

        this.boatMarkers.push({
          position: { lat:  Number(stmap.latitude), lng:  Number(stmap.longitude) },
          name: stmap.name,
          stationId: stmap.id,
          branch: stmap.branch,
          title: stmap.servicetime,
          address: stmap.address,
          floor: stmap.card,
          capacity: stmap.serviceitem,
          village:stmap.phone,
          lat: stmap.latitude,
          lng: stmap.longitude
        })
      }
    });
 
    
  }



  createMarkerOptions(type: string,name: string): google.maps.marker.AdvancedMarkerElementOptions {
    
    let divElement = document.createElement('div');
    let imgElement = document.createElement('img');
    imgElement.src = "/static/images/svg/mapic_bp.svg";

    
    imgElement.width = 30;
    imgElement.alt=name;
    divElement.appendChild(imgElement);

    return {
      content: divElement,
      gmpClickable: true,
    };


  }
 

  showDetail(typeParam:string,nameParam:string,stationIdParam:string,branchParam:string,titleParam:string,addressParam:string,floorParam:string,capacityParam:string,villageParam:string,latParam:string,lngParam:string){
    
    this.callBack.emit(
      {
        type:typeParam,
        name:nameParam,
        stationId:stationIdParam,
        branch:branchParam,
        title:titleParam,
        address:addressParam,
        floor: floorParam,
        capacity: capacityParam,
        village:villageParam,
        lat:latParam,
        lng:lngParam,
      }

    );

  }
  getLocalsendToNative() {
    callparentfun();

  }
  Nativeset(lat:any,lng:any) {
    var latstr=lat.toString();
   
      if(latstr!=""&&(latstr.indexOf("24.8")>-1||latstr.indexOf("24.9")>-1||latstr.indexOf("25.0")>-1)){
        
        const newpost:google.maps.LatLngLiteral = {lat:  lat, lng: lng};
        this.center= newpost;
        this.mapCenter=newpost; 
      }
      else{
        this.center = {
          lat: 24.992970647147626,
          lng: 121.30099572377901
        };
        this.mapCenter =  {
          lat: 24.992970647147626,
          lng: 121.30099572377901
        };
      }

  }

  getLocal() {
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
           
           var lattmp=position.coords.latitude.toString();
           if(lattmp.indexOf("24.8")>-1||lattmp.indexOf("24.9")>-1||lattmp.indexOf("25.0")>-1){
              this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.mapCenter =  {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };  
            }
            else{
              this.center = {
                lat: 24.992970647147626,
                lng: 121.30099572377901
              };
              this.mapCenter =  {
                lat: 24.992970647147626,
                lng: 121.30099572377901
              };
            }

        },
        (error) => {
          console.log('Geolocation error:', error);
        }
      );
    }
    else{
      this.getLocalsendToNative();
    }
    

  }
  changecenter(latitude,longitude) {
    
    this.center = {
      lat: latitude,
      lng: longitude
    };
    this.mapCenter =  {
      lat: latitude,
      lng: longitude
    };

  }


  dragAction(){
   
    this.mapCenter =  {
      lat: this.map.getCenter().lat(),
      lng: this.map.getCenter().lng()
    };
  }

  getDistanceFromLatLonInKm( lat:number, lng:number) {
   
    const R = 6371;
    const centerLat = this.mapCenter.lat;
    const centerLng = this.mapCenter.lng;
    const dLat = (centerLat - lat) * (Math.PI / 180);
    const dLon = (centerLng - lng) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((centerLat) * (Math.PI / 180)) * Math.cos((lat) * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;

    return d <= (environment.trafficSize/1000);
  }

  
  
}
